import React from 'react';
import { Stack, Typography, Card, CardContent, Alert } from '@mui/material';
import { useSegmentQuery } from 'controllers/react-query';
import { EditSegmentField } from './EditSegmentField';

export function SegmentDetail({ segmentId }: { segmentId?: number }) {
  const { data: currentSegment, isFetching, error } = useSegmentQuery(segmentId);

  const type = currentSegment?.segment_type;

  return (
    // NOTE: THIS IS A PLACEHOLDER IMPLEMENTATION BEHIND FEATURE FLAG
    <Stack sx={{ width: '100%' }} key={currentSegment?.id}>
      {/* Loading Indicator */}
      {isFetching ? 'Loading...' : null}

      {/* Error Display */}
      {error ? <Alert severity='error'>{error.message}</Alert> : null}

      {/* Segment Editor */}
      {currentSegment && (
        <Card sx={{ bgcolor: 'surfaceContainer.main' }}>
          <CardContent>
            <Typography variant='titleMedium' gutterBottom>
              {type === 'step' ? 'Lecture Step' : 'Knowledge Check'}
            </Typography>
            <EditSegmentField
              title='Text'
              info='This content explains the topic being taught in this section.'
              segment={currentSegment}
            />
          </CardContent>
        </Card>
      )}
    </Stack>
  );
}
